exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hyperlink-color[data-v-2174cd48]{color:#3b9bf0}[data-v-2174cd48] .ql-container.ql-snow{border:none}[data-v-2174cd48] .ql-align-center img{display:inline-block}", ""]);

// exports
